export default "__VITE_ASSET__0b246c34__"